// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-counter {
  color: rgba(var(--v-theme-on-surface), var(--v-medium-emphasis-opacity));
  flex: 0 1 auto;
  font-size: 12px;
  transition-duration: 150ms;
  white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VCounter/VCounter.css"],"names":[],"mappings":"AAAA;EACE,wEAAwE;EACxE,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;AACrB","sourcesContent":[".v-counter {\n  color: rgba(var(--v-theme-on-surface), var(--v-medium-emphasis-opacity));\n  flex: 0 1 auto;\n  font-size: 12px;\n  transition-duration: 150ms;\n  white-space: nowrap;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
